import React from 'react';
import {
  Coins
} from '@phosphor-icons/react';

/**
 * Displays an estimated credit cost for a heavy AI operation.
 * Used before file uploads and analysis triggers.
 */
const CreditCostEstimate = ({ cost, label, className = '' }) => {
  if (!cost) return null;

  return (
    <div
      className={`flex items-center gap-2 px-3 py-2 rounded-lg bg-[rgba(99,102,241,0.1)] border border-[rgba(99,102,241,0.2)] text-sm ${className}`}
      data-testid="credit-cost-estimate"
    >
      <Coins size={16} className="text-[#6366F1] flex-shrink-0" />
      <span className="text-[#A0AEC0]">
        Estimated {label || 'AI analysis'} cost: <span className="text-white font-semibold">~{cost} credits</span>
      </span>
    </div>
  );
};

export default CreditCostEstimate;
